import Regist from './Regist';
import List from './List';
import View from './View';
import Base from './Base';

import { language } from './Language'


import * as Utils from '../../../Utils';

import * as Hosts from '../../../Hosts';


let icon_location = icon_name => Utils.repo_menu_icon_link(icon_name)



/* Network API Configuration */

const object_type = 'company'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/entities`
const api_crud_route_search = (companycode, id) => `${Hosts.SIMCore_API}/entities/${companycode}/${id}`
const api_list_route = companycode => `${Hosts.SIMCore_API}/entities/list/${companycode}/${object_type}`


/* const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/entities`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/entities/${companycode}`
 */
const base_endpoint = `/entities/${object_type}`
//const base_endpoint = `/entities`

const app_endpoints = {

    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
    
}

/* Data Interface Definition */

const data_interface = {
    id: '',
    info: {
        is_develop: true,
        company:'',
        companycode: '',
        username: '',
        password: '',
        name: '',
        vat:'',
        language: 'pt',
        darkmode: false,
        ativo: true,
        observation: '',

        espap: {
            username: '',
            password: '',
            responsable_name: '',
            responsable_email: '',
            responsable_phone: '',
        },

        legacy_access: {
            host: '',
            database: '',
            user: '',
            password: ''
        },

    },

    addresses: [{
      
        village: '',
        city: '',
        type: [],
        region: '',
        country: '',
        apartado: '',
        localidade: '',
        contats: [],
        principal: '',
        observation: '',
        postal_code: '',
        street_name: '',
        address_detail: '',
    }],
    contacts: [{
        email: '',
        phone: '',
        principal: 'true',
        extensions: [],
        observation: '',
        mobile_phone: '',
        building_number: '',
        person_responsables: [{
            name: '',
            email: '',
            extensions: '',
            observation: '',
            mobile_phone: ''
        }],
    }],
    profile: { name: object_type },
    notifications: []
}


/* MENU Definition */

const menu_config = {
    title: lang => language(lang).sidebar_menu.title,
    path: app_endpoints.base,
    icon: icon_location('user.svg'),
    icon_b: icon_location('user_b.svg'),
    cName: '',
    allow: true,
    create: true,
    edit: true,
    view: true,
    remove: true,

    submenu: [
        {
            
            title: (lang) => language(lang).sidebar_menu.submenu.regist.title,
            path: app_endpoints.regist,
            icon: icon_location('user.svg'),
            icon_b: icon_location('user_b.svg'),
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },
        {
            
            title: lang => language(lang).sidebar_menu.submenu.list.title,
            path: app_endpoints.list,
            icon: icon_location('user.svg'),
            icon_b: icon_location('user_b.svg'),
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },
        {
            title: lang => language(lang).sidebar_menu.submenu.view.title,
            path: app_endpoints.view,
            icon: icon_location('user.svg'),
            icon_b: icon_location('user_b.svg'),
            cName: '',
            allow: true,
            create: true,
            edit: true,
            view: true,
            remove: true,
            submenu: []
        },

    ]
}






const Company = {

    object_type,

    api_crud_base,
    api_crud_route_search,
    api_crud_route,

    data_interface,

    api_list_route,


    language: language,

    menu_config: menu_config,


    components: {
        base: { path: app_endpoints.base, component: Base },
        /*  regist: { path: app_endpoints.regist, component: Regist },
         list:   { path: app_endpoints.list, component: List },
         view:   { path: app_endpoints.view, component: View }, */

        regist: { path: app_endpoints.regist, component: Regist },

        list: { path: app_endpoints.list, component: List },

        view: { path: app_endpoints.view, component: View },
    }
};


export default Company;
